import { render, staticRenderFns } from "./TableCompanyGroup.vue?vue&type=template&id=2e3f72fc&scoped=true"
import script from "./TableCompanyGroup.vue?vue&type=script&lang=js"
export * from "./TableCompanyGroup.vue?vue&type=script&lang=js"
import style0 from "./TableCompanyGroup.vue?vue&type=style&index=0&id=2e3f72fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3f72fc",
  null
  
)

export default component.exports